import { Directive, HostListener, Input, output } from '@angular/core';

export type ScreenPosition = {
  x: number;
  y: number;
};

export type ScreenSwipeDirection = ScreenPosition & {
  direction: 'top' | 'bottom' | 'left' | 'right' | 'unknown';
};

@Directive({
  selector: '[infSwipe]',
  standalone: true,
})
export class SwipeDirective {
  public startCoordinates: ScreenPosition;
  public startTime: number;
  public direction: ScreenSwipeDirection;

  @Input() delay = 1000;

  readonly swipeMove = output<ScreenSwipeDirection>();
  readonly swipeEnd = output<ScreenSwipeDirection>();

  @HostListener('touchstart', ['$event'])
  public onTouchStart(event: TouchEvent): void {
    this.startCoordinates = {
      x: event.touches[0].clientX,
      y: event.touches[0].clientY,
    };
    this.startTime = new Date().getTime();
  }

  @HostListener('touchend', ['$event'])
  public onTouchEnd(event: TouchEvent): void {
    const move = {
      x: event.changedTouches[0].clientX - this.startCoordinates.x,
      y: event.changedTouches[0].clientY - this.startCoordinates.y,
    };
    const duration = new Date().getTime() - this.startTime;

    if (duration > 1000) {
      return;
    }
    if (Math.abs(move.x) < 30 && Math.abs(move.y) < 30) {
      return;
    }
    if (Math.abs(move.x) > Math.abs(move.y * 3)) {
      if (move.x < 0) {
        this.direction = { x: move.x, y: move.y, direction: 'left' };
      } else {
        this.direction = { x: move.x, y: move.y, direction: 'right' };
      }
    }
    if (Math.abs(move.y) > Math.abs(move.x * 3)) {
      if (move.y < 0) {
        this.direction = { x: move.x, y: move.y, direction: 'top' };
      } else {
        this.direction = { x: move.x, y: move.y, direction: 'bottom' };
      }
    }

    this.swipeEnd.emit(this.direction);
  }
}
